// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"9ee9ea69","406":"ea959db0","754":"7cf428ca","787":"46303a30","863":"efeda30c"}[chunkId] + ".chunk.js";
};